import StoredLayout from '../../layouts/StoredLayout'
import InputGroups from './InputGroups'
export default StoredLayout(InputGroups)



// WEBPACK FOOTER //
// ./src/forms/input-groups/index.js